export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const TOGGLE_LOGIN = 'TOGGLE_LOGIN';
export const UPDATE_USER_COLLECTION = 'UPDATE_USER_COLLECTION';

